/** Indian GSTIN (optional). Aligned with AddParty / catalogue visitor register. */
export const GST_IN_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Zz][0-9A-Z]{1}$/;

export function parseOptionalGst(
  raw: string
): { ok: true; value?: string } | { ok: false; message: string } {
  const gstTrim = raw.trim().toUpperCase();
  if (!gstTrim) return { ok: true };
  if (!GST_IN_REGEX.test(gstTrim)) {
    return {
      ok: false,
      message: "GST number format is invalid (15-character GSTIN) or leave it blank.",
    };
  }
  return { ok: true, value: gstTrim };
}
